import { render, staticRenderFns } from "./ConfirmarAdesao.vue?vue&type=template&id=1737d2f8&"
import script from "./ConfirmarAdesao.vue?vue&type=script&lang=ts&"
export * from "./ConfirmarAdesao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports